// import {TENANT_BASE_URL} from "../../../Config/ApiUrl";

export default {
    data() {
        return {
            apiUrl: {
                TEAM_CULTURE: 'team-cultures',
            },
            teamCultureModal: false,
            isTeamCultureModalActive: false,
            confirmationModalActive: false,
            selectedUrl: ''
        }
    },
    methods: {
        getAction(row, action, active) {
            if (action.name === 'edit') {
                this.selectedUrl = `${this.apiUrl.TEAM_CULTURE}/${row.id}`;
                this.isTeamCultureModalActive = true;
            } else if (action.name === 'delete') {
                this.confirmationModalActive = true;
                this.selectedUrl = `${this.apiUrl.TEAM_CULTURE}/${row.id}`;
            }
        },
        closeModal() {
            this.isTeamCultureModalActive = false;
            this.selectedUrl = '';
            this.$emit('reload');
        },
    }
}
